import { pagesPlacesLaborCoreEn } from "./labor-core";

export const pagesPlacesEn = {
  shared: {
    placeStatus: "Place Status",
    status: {
      PLANNED: "Planned",
      ACTIVE: "Active",
      TEMPORARILY_CLOSED: "Temporarily Closed",
      CLOSED: "Closed",
      UNDER_CONSTRUCTION: "Under Construction",
      UNDER_RENOVATION: "Under Renovation",
      PLANNED_CLOSURE: "Planned Closure",
      SUSPENDED: "Suspended",
    },
  },

  laborCore: pagesPlacesLaborCoreEn,

  list: {
    pageTitle: "Places",
    filterPlaceholder: "Search by place name",
    addPlace: "Add Place",
    tabs: {
      all: "All",
      planned: "Planned",
      active: "Active",
      temporarilyClosed: "Temporarily Closed",
      closed: "Closed",
    },
    filters: {
      businessPlaceType: "Business place type",
      businessPlaceTypePlaceholder: "Search by business place type",
      officeType: "Office type",
      officeTypePlaceholder: "Search by office type",
      ownershipType: "Ownership type",
      ownershipTypePlaceholder: "Search by ownership type",
    },
  },

  profile: {
    itemCard: {
      placeName: "Place name",
      officeType: "Office type",
      description: "Description",
      placeStatus: "Place status",
      placeImage: "Place image",
      placeCode: "Place code",
      ownershipType: "Ownership type",
      businessPlaceType: "Business place type",
      establishedDate: "Established date",
      startOfOperationDate: "Start of operation date",
      closingDate: "Closing date",

      address: "Address",

      mainPhoneNumber: "Main phone number",
      mainFaxNumber: "Main fax number",
      mainEmail: "Main email",
      websiteUrl: "Website URL",

      administratorName: "Administrator name",

      totalArea: "Area",
      maxCapacityOfPersons: "Max capacity of persons",
      meetingRoomCount: "Meeting room count",
      parkingSpaceCount: "Parking space count",
      hasCafeteria: "Has cafeteria",
      hasFitnessCenter: "Has fitness center",
      hasSecurityAccessControl: "Has security access control",
      hasSecurityCameras: "Has security cameras",
      hasSecurityGuards: "Has security guards",

      workStyle: "Work style",
      businessHours: "Business hours",
      businessHoursStart: "Start",
      businessHoursEnd: "End",
      hasFlexTime: "Has flex time",
      hasLocalHolidays: "Has local holidays",
      localHolidayMemo: "Local holiday description",
      leaseContractNumber: "Lease contract number",
      leaseStartDate: "Lease start date",
      leaseEndDate: "Lease end date",
      leaseRenewalDate: "Lease renewal date",
    },
    navigation: {
      placeIdInfo: "Place ID Info",
      address: "Address",
      contact: "Contact",
      admin: "Place Administrator",
      facility: "Facility",
      operatingInfo: "Operating Info",
    },
  },
  add: {
    title: "Add Place",
    submitButtonLabel: "Submit",
    progressbar: {
      total: "Total",
      mustItem: "Must Item",
      left: "{{value}}left",
      filled: "filled",
      modeSetting: "Mode Settings",
      mustItemOnly: "Must item only",
    },
  },
  administrators: {
    pageTitle: "Place Administrators",
    tabs: {
      all: "All",
      primary: "Primary",
    },
    primary: "Primary",
    addAdministrator: "Add Administrator",
    filterPlaceholder: "Search by member name, email",
    unassign: "Unassign",
    setToPrimary: "Set to Primary",
    addAdministratorDialog: {
      title: "Add Administrator",
      confirm: "Add",
      role: "Role",
      person: "Person",
      success: "Added administrator successfully",
    },
    assignPrimaryDialog: {
      title: "Set to Primary",
      confirm:
        "{{personName}} will be set as the primary administrator of {{roleName}}.",
      success: "Set to primary successfully",
    },
    unassignDialog: {
      title: "Unassign",
      confirm:
        "Are you sure you want to unassign {{personName}} from {{roleName}}?",
      unassign: "Unassign",
      success: "Unassigned successfully",
    },
    filters: {
      role: "Role",
      rolePlaceholder: "Search by role",
    },
  },
  addSelect: {
    header: {
      headerTitle: "Select Place Type",
    },
    body: {
      selectPlaceType: "Please select the type of place you want to add",
      place: "Place",
      itemCard: {
        requiredDetails: "Required Fields",
        placeName: "Place Name",
        postalCode: "Postal Code",
        prefecture: "Prefecture",
        city: "City",
        address: "Street Address",
        contactInfo: "Contact Information",
        businessHours: "Business Hours",
        storageInfo: "Storage Facility Info",
        securityInfo: "Security Information",
        basicInfo: "Basic Information",
      },
      fillOutDetails: "Fill Out Details",
    },
    options: {
      description: "Or...",
      csvImport: "Bulk Upload via CSV",
      bulkRegister: "Sync with External System",
    },
  },
  importCsv: {
    title: "Bulk Import Places from CSV",
    unit: "items",
    exportFilename: "places-list",
    prepareCsvFile: {
      templateTitle: "Place CSV Template",
      updateExisting:
        "To update existing place information, include the Place ID",
    },
    completeDialog: {
      button: "Return to Places List",
    },
    columns: {
      name: "Place Name",
      code: "Place Code",
      status: "Status",
      officeType: "Office Type",
      postalCode: "Postal Code",
      stateProvince: "State/Province",
      city: "City",
      streetAddress: "Street Address",
      phoneNumber: "Phone Number",
      email: "Email",
      maxCapacity: "Max Capacity",
      businessPlaceType: "Business Place Type",
    },
  },
};
